/**
 * Number of days threshold to consider a user as "new" for benefits block features
 * Used to determine if onboarding benefits should be shown to users
 */
export const NEW_USER_THRESHOLD_DAYS = 31;
